import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import { BadgeColors, IssueCountBadge } from '../../../generic';
import type { Snippet, SnippetLicensingIssueCounts, SnippetSecurityIssueCounts } from '../../../../../shared/snippets';
import type { IssueCountBadgeProps } from '../../../generic/Badge/IssueCountBadge';

import styles from './IssueCounts.module.less';

function snippetLicensingIssueCountsToBadgeCounts(issueCounts: SnippetLicensingIssueCounts): IssueCountBadgeProps['issueTypes'] {
  return {
    policy_conflict: issueCounts.denied,
    policy_flag: issueCounts.flagged,
    unlicensed_dependency: issueCounts.unknown,
  };
}

function snippetSecurityIssueCountsToBadgeCounts(issueCounts: SnippetSecurityIssueCounts): IssueCountBadgeProps['issueTypes'] {
  return issueCounts;
}

export type Props = {
  snippet: Snippet;
};

/**
 * Component which displays issue counts for a snippet.
 * This uses the newer "dots" design.
 */
const IssueCounts: VoidFunctionComponent<Props> = ({ snippet }) => {
  if (snippet.rejectionDetails) {
    return <div>Unavailable for rejected snippets</div>;
  }

  const totalLicensingIssues = _.sum(Object.values(snippet.issueCounts.licensing));
  const totalSecurityIssues = _.sum(Object.values(snippet.issueCounts.security));
  if (totalLicensingIssues === 0 && totalSecurityIssues === 0) {
    return <div>No issues found</div>;
  }

  return (
    <div className={styles.issueCountBadges}>
      {totalLicensingIssues > 0 && (
        <IssueCountBadge
          id={`${snippet.locator}-licensing`}
          pluralLabel={() => 'licensing'}
          issueTypes={snippetLicensingIssueCountsToBadgeCounts(snippet.issueCounts.licensing)}
          color={BadgeColors.White}
        />
      )}
      {totalSecurityIssues > 0 && (
        <IssueCountBadge
          id={`${snippet.locator}-security`}
          pluralLabel={() => 'security'}
          issueTypes={snippetSecurityIssueCountsToBadgeCounts(snippet.issueCounts.security)}
          color={BadgeColors.White}
        />
      )}
    </div>
  );
};

export default IssueCounts;
